<template>
  <div class="BG_Dimmed_02 disable_wrap">
    <div class="close_icon" @click="closepop">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" :d="closeSvgPath" class="Icon_Color_on"/>
      </svg>
    </div>{{ device }}
      <div class="text_wrap_text" >
        <div class="text_wrap">
          <p :class="[`B${fontSize+4} Text_Color_on`]">회원가입을 하고</p>
          <p :class="[`B${fontSize+4} Text_Color_on`]">편리한 서비스를 이용하세요</p>
        </div>
        
        <div class="btn_wrap" :style="{width: device !== 'PC' ? '' : '500px' }">
          <div :class="[,`B${fontSize+4} main_button_1`]" @click="gotoLogin">로그인</div>
          <div :class="[ `B${fontSize+4} main_button_2`]" @click="gotoSignUp">회원가입</div>
        </div>
      </div>
    </div>
</template>

<script>

import { closeSvgPath } from '@/store/icons'
export default {
  emits:['closepop'],
  data(){
    return {
      fontSize: this.$store.state.fontSize,
      closeSvgPath:closeSvgPath,
      device: null,
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    this.isMobile()
  },
  unmounted() {
    document.body.style.overflow = '';
  },
  methods: {
    closepop(){
      this.$emit('closePopup',false)
    },
    gotoLogin(){
      this.$router.push("/login")
    },
    gotoSignUp(){
      this.$movePage('M', 'register')
      //this.$router.push("/application/register")
    },
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Android, iOS, Windows Phone 등 주요 모바일 기기를 확인
      if (/android/i.test(userAgent)) {
          this.device = '안드로이드';
          return true;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          this.device = '애플';
          return true;
      }

      if (/windows phone/i.test(userAgent)) {
          this.device = '윈도우';
          return true;
      }

      // 기타 모바일 기기 확인
      if (/mobile/i.test(userAgent)) {
          this.device = '몰러';
          return true;
      }

      this.device = 'PC';
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
  .disable_wrap{
    width: 100%;
    height: 100vh;
    position: absolute; 
    left: 0;
    top: 0;
    z-index: 9999999;   
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    justify-content: center;

    .close_icon{
      display: flex;  
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    .text_wrap_text{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    
        .text_wrap{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 64px;
          text-align: center;
          
        }
    }
    .btn_wrap{
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 12px;

    }
  }

</style>